import React from "react";

const ModalBackground = ({ children }) => {
  return <div className="fixed inset-0 ">{children}</div>;
};

export const ModalContainer = ({ children }) => {
  return (
		<div className="fixed inset-0 bg-primary bg-opacity-10 flex justify-center items-center">
			{children}
		</div>
	);
};

export default ModalBackground;
